import { FC } from 'react';
import { ActiveCodeDataSource, PendingCodeDataSource } from './code';
import { OverviewTabProps } from './types/types';

export const CodeOverview: FC<OverviewTabProps> = ({ dataSource, isActive }) => {
  return <>{isActive ? <ActiveCodeDataSource dataSource={dataSource} /> : <PendingCodeDataSource dataSource={dataSource} />}</>;
};
